import { Box, CircularProgress } from "@mui/material";
import React from "react";

const Loader = ({ height = "350px" }) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        height: height,
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
